export function countries(state){
    return state.countries
}

export function country(state){
    return state.country
}

export function courses(state){
    return state.courses
}